<template>

	<!-- content -->
	<div id="content" class="content find">
		<div class="container">
			<!-- 페이지 타이틀 -->
			<div class="page-title">
				<h2 class="tit">아이디 찾기</h2>
				<p class="sub-tit">가입 시에 등록한 정보를 입력해 주세요.</p>
			</div>
			<form @submit.prevent="doSearch">
				<div class="find-form gui-form">
					<div class="row-box">
						<label class="label" for="name">이름</label>
						<div class="inp-set">
							<input id="name" name="name" type="text" placeholder="이름" v-model="userName" required="required">
						</div>
					</div>
					<div class="row-box">
						<label class="label" for="phoneNo">휴대전화</label>
						<div class="inp-set">
							<input id="phoneNo2" name="phoneNo2" type="tel" placeholder="‘-’생략하고 입력" v-model="phoneNo" required="required">
						</div>
<!--						<div class="sel-inp-set">
							<select id="phoneNo" name="phoneNo">
								<option value="010">010</option>
								<option value="011">011</option>
								<option value="016">016</option>
								<option value="017">017</option>
								<option value="018">018</option>
								<option value="019">019</option>
							</select>
							<input id="phoneNo2" name="phoneNo2" type="text" placeholder="‘-’생략하고 입력">
						</div>-->
					</div>
<!--					<div class="row-box">
						<label class="label" for="authNo">인증번호</label>
						<div class="inp-btn-set">
							<input type="text" name="authNo" id="authNo" placeholder="인증번호 입력" disabled>
							<button type="button">인증 번호 확인</button>
						</div>
						<p class="information">발송된 인증 메일의 6자리 인증 번호를 입력해주세요.</p>
					</div>-->
				</div>
				<div class="btn-area">
					<button type="submit" class="btn-submit">아이디 찾기</button>
				</div>
			</form>
		</div>
	</div>
	<!--//content -->

</template>

<script>
export default {
	name: "findId",
	data () {

		return {
			userName: "",
			phoneNo: "",
		}
	},
	created() {

	},
	methods: {

		doSearch (e) {

			e.preventDefault()

			const self = this
			this.$eventBus.$emit("startProgress")
			this.axiosCaller.get(this, this.APIs.CO_ACCOUNT + "/doFindEmail", {
				userName: this.userName,
				phoneNo: this.phoneNo,
			}, (res) => {
				this.$eventBus.$emit("doneProgress")

				const result = res.data;
				if (result.status === "ok") {
					const coEmailIdArr = result.coEmailId.split("@");
					const emailEnc = self.stringUtils.idFilter( coEmailIdArr[0] ) + "@" + coEmailIdArr[1];
					self.swalUtils.fire("계정확인", emailEnc, "success")
					.then(() => {
						self.userName = "";
						self.phoneNo = "";
					});
				} else {
					self.swalUtils.gritter(result.warnLevel == 1 ? "Info" : "Error", result.msg, result.warnLevel == 1 ? "info" : "error", 5000);
				}
			})


		}

	}
}
</script>

<style scoped>

</style>